import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import { PROFILES } from "./apiRoutes";
import axiosAuth from "../axiosAuth";

export interface Profile {
  id: string;
  name: string;
  email: string;
  mobile_number?: string;
  role: string;
  city: string;
  state: string;
  geographical_region_id: string;
  description?: string;
  createdAt: string;
  isActive: boolean;
}

export interface ProfilesResponse {
  data: {
    records: Profile[];
    pagination: { totalRecords: number }[];
  }[];
}

const fetchProfilesByRole = async ({ 
  role, 
  params = {} 
}: { 
  role: string; 
  params?: FieldValues 
}) => {
  const response = await axiosAuth.get<ProfilesResponse>(PROFILES, {
    params: {
      ...params,
      role,
      status: true, // Only fetch active profiles
    },
  });
  return response.data;
};

export const useProfilesByRoleQuery = (
  role: string,
  params?: FieldValues,
  queryParams?: Omit<
    UseQueryOptions<
      ProfilesResponse,
      Error,
      ProfilesResponse,
      ["profiles", string, FieldValues]
    >,
    "queryKey" | "queryFn"
  >
) =>
  useQuery<ProfilesResponse, Error, ProfilesResponse, ["profiles", string, FieldValues]>({
    queryKey: ["profiles", role, params || {}],
    queryFn: () => fetchProfilesByRole({ role, params }),
    enabled: !!role,
    ...(queryParams || {}),
  });
